// @flow

import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Button } from '@material-ui/core';

import { TitleContentCMS } from '../../../data/cms/types/common';

import './style.css';

type Props = {
    Content: TitleContentCMS,
    onSupportClick:Function
};

function ContactSupport(props: Props) {
    const { Content,onSupportClick } = props;

    return (
        <Typography component="div" className="contact-banner">
            <Typography component="h5">{Content.Title}</Typography>
            <Typography component="p">{Content.Content}</Typography>
            {/*<Button variant="contained"  onClick={onSupportClick} color="primary">
                CONTACT SUPPORT
    </Button>*/}
        </Typography>
    );
}

ContactSupport.propTypes = {
    Content: PropTypes.object.isRequired
};

export default ContactSupport;
